import { GridColDef } from "@mui/x-data-grid-pro";
import { AddGeneralCodeDialog } from "components/alove/AddGeneralCodeDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { TwoSizeChip } from "components/alove/Chips";
import { TablePage } from "components/alove/TablePage";
import { setCurrentDialog, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { Content, ContentType } from "models/content/Content";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { getContents, getContentStats, publishContents } from "utils/contentUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { capitalize } from "@mui/material";
import { useEffect, useState } from "react";
import { UpdateGeneralCodeDialog } from "components/alove/UpdateGeneralCodeDialog";
import { EditGeneralCodeDialog } from "components/alove/EditGeneralCodeDialog";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export const ContentsList = () => {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const { type } = useParams();
  const [refresh, setRefresh] = useState(false);
  const [categories, setCategories] = useState<GeneralCode[]>([]);

  const [currentCategory, setCurrentCategory] = useState<GeneralCode | null>(null);

  const columns: GridColDef[] = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      valueGetter: (v) => camelCaseToCapitalizedWords(v),
    },
    {
      headerName: "Type",
      field: "type",
      valueFormatter: (v) => capitalize(ContentType[v] || ""),
      flex: 1,
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      renderCell: (params) => {
        const content: Content = Object.assign(new Content(), params.row);
        return (
          content.statusId && (
            <TwoSizeChip label={content.statusLabel} color={content.statusColor as any} />
          )
        );
      },
    },
  ];

  const loadContents = async () => {
    const contents = await getContents(parseInt(type!));
    setCategories(contents.map((c) => c.category));
    return contents;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={ContentType[type!] || "Contents"} />
      <TablePage
        actions={{
          title: "Contents actions",
          saveActions: [
            {
              label: "Publish",
              variant: "contained",
              role: PermissionType.Publish,
              onClick: () => publishContents(),
            },
          ],
          addActions: [
            {
              label: "Content",
              onClick: () => navigate(`/contentsCenter/${type}/new`),
              variant: "contained",
              color: "secondary",
            },
            {
              label: "Category",
              onClick: () => setCurrentDialog(dispatch, DialogType.AddGeneralCode),
              variant: "contained",
              color: "secondary",
            },
          ],
        }}
        refresh={refresh} 
        table={{
          loadNext: loadContents,
          columns,
          lineClick: (content) =>
            !isNaN(content.id) && navigate(`/contentsCenter/${type}/${content.id}`),
          getTreeDataPath: (content) => [content.category?.name || "No category", `#${content.id}`],
          lineDoubleClick: (content) => {
            if (isNaN(content.id)) {
              const category = categories.find((c) => c.name == content.id.split("/")[1])!;
              setCurrentCategory(category);
              setCurrentDialog(dispatch, DialogType.EditGeneralCode);
            }
          },
        }}
        title="Contents"
      />
      <AddGeneralCodeDialog type={GeneralCodeType.ContentCategory} entity="Category" />
      {currentCategory && (
        <EditGeneralCodeDialog entity="Category" code={currentCategory!} refresh={() => setRefresh(!refresh)} />
      )}
    </DashboardLayout>
  );
};
